import React, { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { Spinner, Alert as BootStrapALert } from 'react-bootstrap';
import {
  HemaHeadingWithSubText,
  HemaLabel,
  Button,
  Alert,
  FormSelect,
} from '../../utils';
import {
  CrossIcon,
  EyeIcon,
  HideEye,
  NameInformation,
  SelectDownArrow,
  TickGreen,
} from '../../HemeIconLibrary';
import { showErrorReducer } from '../../Store/reducers/uiSettings';
import { saveAllQuestionsForNewPassword } from '../../Actions/auth';
import LoginInput from '../../utils/FormElements/loginInput';

const Index = ({ allQuestion, token, setVerifyLink }) => {
  const [showPassword, setshowPassword] = useState(false);
  const [showPassword2, setshowPassword2] = useState(false);
  const [showPassword3, setshowPassword3] = useState(false);
  const [questionsOptions, setQuestionsOptions] = useState([]);
  const [formikValue, setFormikValues] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    setQuestionsOptions(allQuestion);
  }, [allQuestion]);

  useEffect(() => {
    if (formikValue) {
      setQuestionsOptions(
        allQuestion.filter(
          (data) =>
            ![
              String(formikValue.question1),
              String(formikValue.question2),
              String(formikValue.question3),
            ].includes(String(data.id))
        )
      );
    }
  }, [formikValue]);
  return (
    <div className="max-w-[450px]">
      <HemaHeadingWithSubText
        heading="Set Security Questions "
        sub="Select the security questions from below. These questions will help us verify your identity should you forget your password."
        subTextColor="#595959"
      />
      <div className="mt-[10px]">
        <BootStrapALert variant="success ">
          <TickGreen />
          Your password has been succesfully saved.
        </BootStrapALert>
      </div>
      <Formik
        initialValues={{
          question1: '',
          question2: '',
          question3: '',
          answer1: '',
          answer2: '',
          answer3: '',
        }}
        innerRef={(formikActions) => setFormikValues(formikActions?.values)}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (values.question1 === '') {
            errors.question1 = 'Required';
          }
          if (values.question2 === '') {
            errors.question2 = 'Required';
          }
          if (values.question3 === '') {
            errors.question3 = 'Required';
          }
          if (values.answer1 === '') {
            errors.answer1 = 'Required';
          } else if (values.answer1.length <= 4) {
            errors.answer1 = 'answer length should be greater then 4 character';
          }
          if (values.answer2 === '') {
            errors.answer2 = 'Required';
          } else if (values.answer2.length <= 4) {
            errors.answer2 = 'answer length should be greater then 4 character';
          }
          if (values.answer3 === '') {
            errors.answer3 = 'Required';
          } else if (values.answer3.length <= 4) {
            errors.answer3 = 'answer length should be greater then 4 character';
          }

          dispatch(showErrorReducer(''));
          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);

          const questionVerify = await saveAllQuestionsForNewPassword({
            questions: [
              {
                questionId: values.question1,
                answer: values.answer1,
              },
              {
                questionId: values.question2,
                answer: values.answer2,
              },
              {
                questionId: values.question3,
                answer: values.answer3,
              },
            ],
            invitationToken: token,
          });
          setSubmitting(false);
          if (questionVerify.status === 200) {
            setVerifyLink('set-question-success');
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="mt-[24px]">
                <Alert type="error" />
              </div>

              <div className="flex flex-col  mb-[24px] mt-[24px] set-security-questions">
                <HemaLabel
                  text="Question 1"
                  Icon={<NameInformation />}
                  textSize="text-[16px]"
                  className="mb-[15px]"
                  required
                />
                <FormSelect
                  options={questionsOptions}
                  placeholder="Select question"
                  setFieldValue={setFieldValue}
                  name="question1"
                  value={values.question1}
                  crossIcon={values.question1 ? <CrossIcon /> : ''}
                  dropIcon={<SelectDownArrow />}
                />
                <p className="error m-0 text-sm text-[#F54C3B]">
                  {errors.question1 && touched.question1 && errors.question1}
                </p>
                <LoginInput
                  type={showPassword ? 'text' : 'password'}
                  name="answer1"
                  placeholder="Enter answer"
                  value={values.answer1}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  crossIcon={values.answer1 ? <CrossIcon /> : ''}
                  inputIcon={
                    values.answer1 ? (
                      !showPassword ? (
                        <EyeIcon />
                      ) : (
                        <HideEye />
                      )
                    ) : (
                      ''
                    )
                  }
                  setshowPassword={setshowPassword}
                  showPassword={showPassword}
                />
                <p className="error m-0 text-sm text-[#F54C3B]">
                  {errors.answer1 && touched.answer1 && errors.answer1}
                </p>
              </div>
              <div className="flex flex-col  mb-[24px] set-security-questions">
                <HemaLabel
                  text="Question 2"
                  Icon={<NameInformation />}
                  textSize="text-[16px]"
                  className="mb-[15px]"
                  required
                />
                <FormSelect
                  options={questionsOptions}
                  placeholder="Select question"
                  setFieldValue={setFieldValue}
                  name="question2"
                  value={values.question2}
                  dropIcon={<SelectDownArrow />}
                  crossIcon={values.question2 ? <CrossIcon /> : ''}
                />
                <p className="error m-0 text-sm  text-[#F54C3B]">
                  {errors.question2 && touched.question2 && errors.question2}
                </p>
                <LoginInput
                  type={showPassword2 ? 'text' : 'password'}
                  name="answer2"
                  placeholder="Enter answer"
                  value={values.answer2}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  crossIcon={values.answer2 ? <CrossIcon /> : ''}
                  inputIcon={
                    values.answer2 ? (
                      !showPassword2 ? (
                        <EyeIcon />
                      ) : (
                        <HideEye />
                      )
                    ) : (
                      ''
                    )
                  }
                  setshowPassword={setshowPassword2}
                  showPassword={showPassword2}
                />
                <p className="error m-0 text-sm text-[#F54C3B]">
                  {errors.answer2 && touched.answer2 && errors.answer2}
                </p>
              </div>
              <div className="flex flex-col  mb-[40px]  set-security-questions">
                <HemaLabel
                  text="Question 3"
                  Icon={<NameInformation />}
                  textSize="text-[16px]"
                  className="mb-[15px]"
                  required
                />
                <FormSelect
                  options={questionsOptions}
                  placeholder="Select question"
                  setFieldValue={setFieldValue}
                  name="question3"
                  value={values.question3}
                  dropIcon={<SelectDownArrow />}
                  crossIcon={values.question3 ? <CrossIcon /> : ''}
                />
                <p className="error m-0 text-sm text-[#F54C3B]">
                  {errors.question3 && touched.question3 && errors.question3}
                </p>
                <LoginInput
                  type={showPassword3 ? 'text' : 'password'}
                  name="answer3"
                  placeholder="Enter answer"
                  value={values.answer3}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  crossIcon={values.answer3 ? <CrossIcon /> : ''}
                  inputIcon={
                    values.answer3 ? (
                      !showPassword3 ? (
                        <EyeIcon />
                      ) : (
                        <HideEye />
                      )
                    ) : (
                      ''
                    )
                  }
                  setshowPassword={setshowPassword3}
                  showPassword={showPassword3}
                />
                <p className="error m-0 text-sm text-[#F54C3B]">
                  {errors.answer3 && touched.answer3 && errors.answer3}
                </p>
              </div>

              {isSubmitting ? (
                <Button
                  type="submit"
                  bg="bg-primary1"
                  className="w-full h-[48px] justify-center font-semibold"
                  text={
                    <>
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                    </>
                  }
                />
              ) : (
                <Button
                  text="Save"
                  type="submit"
                  bg="bg-primary1"
                  border="border-primary1"
                  disabled={
                    values.question1 &&
                    values.question2 &&
                    values.question3 &&
                    values.answer1 &&
                    values.answer2 &&
                    values.answer3 &&
                    Object.keys(errors)?.length === 0
                      ? false
                      : true
                  }
                  color="text-white"
                  className="w-full h-[48px] justify-center font-semibold"
                />
              )}
            </form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default Index;
